import React from 'react';

interface PagePlaceholderProps {
  title: string;
  body: string;
  categoryLabel?: string;
  modules: Array<{ id: string; label: string; description: string }>;
}

const PagePlaceholder: React.FC<PagePlaceholderProps> = ({
  title,
  body,
  categoryLabel,
  modules,
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center text-muted-foreground">
      {categoryLabel && (
        <div className="text-xs font-semibold uppercase tracking-wider mb-2 opacity-70">
          {categoryLabel}
        </div>
      )}
      <h2 className="text-2xl font-bold mb-4 text-foreground">{title}</h2>
      <p className="max-w-md mb-8">{body}</p>
      
      {modules.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl w-full">
          {modules.map((mod) => (
            <div 
              key={mod.id} 
              className="p-4 border rounded-lg bg-card text-card-foreground shadow-sm flex flex-col items-start text-left"
            >
              <span className="font-semibold mb-1">{mod.label}</span>
              <span className="text-xs opacity-70">{mod.description}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PagePlaceholder;
